import { FACILITYNAME, FILTER_SELECTION, HEALTH_PACKAGES_STATUS, HISSYSTEM, getFacilityId, getfacilityName } from '../../../Common/Utility/constants';
import {
  sendSmPageViewEvent,
  sendSmSelectItemEvent,
  sendSmViewItemListEvent,
  sendSmViewItemEvent,
  sendSmClickaShareEvent,
  sendSmPackageBookingEvent,
  sendSmPackageBookingErrorEvent,
  sendSmCancelPackagesEvent,
  sendSmRebookPackagesEvent,
  sendSmViewAllLinkEvent,
  sendSmFilterClickEvent,
  sendSmInfoPopupViewedEvent
} from './packages-smartlook-events';
import { dataLayerSendEvent as sendEventData} from '../../../Common/Utility/analytics-utils';
import { MY_ASTER_CATEGORY, PACKAGE_TYPE, PAGE_NAME, SCREEN_NAME, TYPE, ERROR_TYPE } from '@common/Constants/analytics';

export const dataLayerSendEvent = (eventName, data) => {
  sendEventData(eventName, data);
};

export const getPackageobject = (packageItem) => ({
  package_id: String(packageItem?.packageId) || String(packageItem?.packageDetails?.packageId) || String(packageItem?.id) || '',
  package_name: packageItem?.name || packageItem?.packageDetails?.title || '',
  price: packageItem?.netPrice || packageItem?.patientPayableAmount || packageItem?.price || '',
  currency: 'AED',
  promotion_discount: packageItem?.savedAmount || packageItem?.SavedAmount || packageItem?.discount || '',
  no_of_services: packageItem?.packageContentSize || packageItem?.countOfServicesListed || '',
  ...(packageItem?.isHomeSampleCollectionAllowed !== undefined &&
  packageItem?.isHomeSampleCollectionAllowed !== 'undefined'
    ? { package_type: packageItem?.isHomeSampleCollectionAllowed ? PACKAGE_TYPE?.HOME_SAMPLE : PACKAGE_TYPE?.CLINIC_PACKAGE }
    : {}),
  promotion_name: packageItem?.isMyAsterExclusive ? PACKAGE_TYPE?.MYASTER_EXCLUSIVE : null,
  speciality: packageItem?.speciality || '',
  ...(packageItem?.index ?{index: packageItem?.index}: {}),
});

export const sendSelectPackageEvent = (
  packageItem,
  screenName,
  pageType,
  refererPage,
  sectionName,
  packageId,
  facilityId,
  facilityName,
) => {
  const itemData = {
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
    page_type: pageType,
    screen_name: screenName,
    ...(sectionName ? {section_name : sectionName} : {}),
    ...(refererPage ? { referrer_page: refererPage?.toLowerCase() } : {}),
    package_id: packageId || '',
    package_name: packageItem?.name || packageItem?.packageDetails?.title || '',
    price: packageItem?.netPrice || packageItem?.patientPayableAmount || packageItem?.price || '',
    currency: 'AED',
    promotion_discount: packageItem?.savedAmount || packageItem?.SavedAmount || packageItem?.discount || '',
    no_of_services: packageItem?.packageContentSize || packageItem?.countOfServicesListed || '',
    ...(packageItem?.isHomeSampleCollectionAllowed !== undefined &&
    packageItem?.isHomeSampleCollectionAllowed !== 'undefined'
      ? { package_type: packageItem?.isHomeSampleCollectionAllowed ? PACKAGE_TYPE?.HOME_SAMPLE : PACKAGE_TYPE?.CLINIC_PACKAGE }
      : {}),
    promotion_name: packageItem?.isMyAsterExclusive ? PACKAGE_TYPE?.MYASTER_EXCLUSIVE : null,
    speciality: packageItem?.speciality || '',
    ...(facilityId ? { facility_id: facilityId } : {}),
    ...(facilityName ? { facility_name: facilityName } : {}),
    ...(packageItem?.hisSystemName ? { facility_type: packageItem?.hisSystemName === HISSYSTEM?.AKHIL ? FACILITYNAME?.HOSPITAL : FACILITYNAME?.CLINIC } : {}),
  };
  dataLayerSendEvent('select_package', itemData);
  const selectedItem = { ...itemData };
  delete selectedItem?.ecommerce;
  sendSmSelectItemEvent('select_package', selectedItem);
};

export const packageViewitemListEvent = (
  items,
  sectionName,
  pageType,
  screenName,
  referrerPage,
  facilityName,
  facilityId,
  isFromFacility,
) => {
  const itemData = {
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
    page_type: pageType,
    screen_name: screenName,
    section_name: sectionName,
    ...(referrerPage ? { referrer_page: referrerPage?.toLowerCase() } : {}),
    ecommerce: {
      items: items?.map((element, index) => ({
        ...getPackageobject(element),
        index: index + 1,
        ...(facilityId ? { facility_id: facilityId } : {}),
        ...(facilityName !== 'undefined' && facilityName !== undefined ? { facility_name: facilityName } : {}),
        ...(isFromFacility ? { facility_type: element?.hisSystemName === HISSYSTEM?.AKHIL ? FACILITYNAME?.HOSPITAL : FACILITYNAME?.CLINIC} : {}),
      })),
    },
  };

  dataLayerSendEvent('view_item_list', itemData);

  const smItemData = {
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
    page_type: pageType,
    screen_name: screenName,
    section_name: sectionName,
  };

  sendSmViewItemListEvent('view_item_list', smItemData);
};

export const sendViewPackageEvent = (details, screenName, pageType, referrerPage, facilityName, facilityId) => {
  const itemData = {
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
    page_type: pageType,
    screen_name: screenName,
    referrer_page: referrerPage,
    package_id: String(details?.packageId) || String(details?.packageDetails?.packageId) || String(details?.id) || '',
    package_name: details?.name || details?.packageDetails?.title || '',
    price: details?.netPrice || details?.patientPayableAmount || details?.price || '',
    currency: 'AED',
    promotion_discount: details?.savedAmount || details?.SavedAmount || details?.discount || '',
    no_of_services: details?.packageContentSize || details?.countOfServicesListed || '',
    ...(details?.isHomeSampleCollectionAllowed !== undefined && details?.isHomeSampleCollectionAllowed !== 'undefined'
      ? { package_type: details?.isHomeSampleCollectionAllowed ? PACKAGE_TYPE?.HOME_SAMPLE : PACKAGE_TYPE?.CLINIC_PACKAGE }
      : {}),
    promotion_name: details?.isMyAsterExclusive ? PACKAGE_TYPE?.MYASTER_EXCLUSIVE : null,
    speciality: details?.speciality || '',
    ...(facilityId ? { facility_id: facilityId } : {}),
    ...(facilityName ? { facility_name: facilityName } : {}),
    ...(details?.hisSystemName ? { facility_type: details?.hisSystemName === HISSYSTEM?.AKHIL ? FACILITYNAME?.HOSPITAL : FACILITYNAME?.CLINIC } : {}),
  };
  dataLayerSendEvent('view_package', itemData);

  const smItemData = {
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
    page_type: pageType,
    screen_name: screenName,
    referrer_page: referrerPage,
  };
  sendSmViewItemEvent('view_package', smItemData);
};

export const sendPackagePageviewEvent = (screenName, category, pageType, referrerPage, pageId) => {
  const itemData = {
    screen_name: screenName,
    myaster_category: category,
    ...(pageType ? { page_type: pageType } : {}),
    ...(pageId ? { page_id: pageId } : {}),
    ...(referrerPage ? { referrer_page: referrerPage?.toLowerCase() } : {}),
  };
  dataLayerSendEvent('page_view', itemData);
  sendSmPageViewEvent('page_view', itemData);
};

export const sendMyPackagePageviewEvent = (screenName, category, pageType, tabName) => {
  const itemData = {
    screen_name: screenName,
    myaster_category: category,
    ...(pageType ? { page_type: pageType } : {}),
    ...(tabName ? { tab_name: tabName } : {}),
  };
  dataLayerSendEvent('page_view', itemData);
  sendSmPageViewEvent('page_view', itemData);
};

export const sendPackageBookingPageViewEvent = (
  screenName,
  category,
  pageType,
  bookingDetails,
  paymentType,
  referrerPage = '',
) => {
  const itemData = {
    screen_name: screenName,
    oneaster_category: category,
    page_type: pageType,
    referrer_page: referrerPage,
    package_id: String(bookingDetails?.packageId) || String(bookingDetails?.packageDetails?.packageId) || '',
    package_name: bookingDetails?.name || bookingDetails?.packageDetails?.title || '',
    unit_price: bookingDetails?.netPrice || bookingDetails?.patientPayableAmount || '',
    promotion_discount: bookingDetails?.promotionAmount,
    no_of_services: bookingDetails?.noOfService,
    secure_points_earned: bookingDetails?.securePoints,
    patient_name: bookingDetails?.patientDetails?.name,
    facility_name: bookingDetails?.clinicDetails?.name,
    payment_method: paymentType,
  };
  dataLayerSendEvent('page_view', itemData);
};

export const checkPackageDetailClickEvent = (data, screenName, pageType, homeSampleStatement, paymentStatus, referenceNumber) => {
  const itemData = {
    screen_name: screenName,
    page_type: pageType,
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
    referrer_page: 'package checkout page',
    package_name: data?.packageDetails?.title,
    ...(homeSampleStatement ? {package_type : homeSampleStatement} : {}),
    price: data?.patientPayableAmount,
    package_id: String(data?.packageDetails?.packageId),
    facility_id: data?.clinicDetails?.id,
    facility_name: data?.clinicDetails?.name,
    ...(data?.hisSystemName !== undefined ? {facility_type : data?.hisSystemName === HISSYSTEM?.AKHIL ? FACILITYNAME?.HOSPITAL : FACILITYNAME?.CLINIC} :{}),
    payment_status: paymentStatus,
    package_status: paymentStatus === 'paid' ? HEALTH_PACKAGES_STATUS?.CONFIRMED : HEALTH_PACKAGES_STATUS?.RESERVED,
    booking_id: referenceNumber,
  };
  dataLayerSendEvent('check_packages_details_click', itemData);
};

export const packageRebook = (packageDetail, screenName, pageType) => {
  const itemData = {
    screen_name: screenName,
    page_type: pageType,
    package_name: packageDetail?.packageDetail?.name || '',
    package_type: packageDetail?.isHomeSampleCollectionAllowed ? PACKAGE_TYPE?.HOME_SAMPLE : PACKAGE_TYPE?.CLINIC_PACKAGE,
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
    payment_amount: packageDetail?.packageDetail?.netPrice,
  };

  dataLayerSendEvent('rebook_package', itemData);

  const smRebookData = { ...itemData };
  delete smRebookData?.payment_amount;

  sendSmRebookPackagesEvent('rebook_package', smRebookData);
};

export const packageCancel = (packageDetail, screenName, pageType, Reason_of_cancel) => {
  const itemData = {
    screen_name: screenName,
    page_type: pageType,
    package_name: packageDetail?.packageDetail?.name || '',
    booking_id: packageDetail?.packageDetail?.bookingId || '',
    package_type: packageDetail?.isHomeSampleCollectionAllowed ? PACKAGE_TYPE?.HOME_SAMPLE : PACKAGE_TYPE?.CLINIC_PACKAGE,
    price: packageDetail?.packageDetail?.netPrice,
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
    package_status: packageDetail?.packageDetail?.bookingStatus?.toLowerCase(),
    payment_amount: packageDetail?.packageDetail?.netPrice,
    speciality: packageDetail?.packageDetail?.speciality,
    reason_of_cancel: Reason_of_cancel,
  };
  dataLayerSendEvent('cancel_package', itemData);

  const smCancelData = {
    screen_name: screenName,
    page_type: pageType,
    booking_id: packageDetail?.packageDetail?.bookingId || '',
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
    reason_of_cancel: Reason_of_cancel,
  };
  sendSmCancelPackagesEvent('cancel_package', smCancelData);
};


export const packageBookingError = (paymentType, clinicData, packageData, errorMessage = '', price) => {
  const itemData = {
    screen_name: 'package checkout',
    page_type: PAGE_NAME?.PACKAGE,
    package_name: packageData?.name,
    package_type: packageData?.isHomeSampleCollectionAllowed ? PACKAGE_TYPE?.HOME_SAMPLE : PACKAGE_TYPE?.CLINIC_PACKAGE,
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
    payment_amount: price,
    payment_type: paymentType?.toLowerCase(),
    error: 'Something went wrong',
    err_type: ERROR_TYPE.API_ERROR,
    facility_type: packageData?.hisSystemName === HISSYSTEM?.AKHIL ? FACILITYNAME?.HOSPITAL : FACILITYNAME?.CLINIC,
    facility_name: getfacilityName(clinicData?.name, packageData?.isHomeSampleCollectionAllowed),
  };
  dataLayerSendEvent('package_booking_error', itemData);

  const smErrorData = {...itemData};
  delete smErrorData?.payment_amount;
  sendSmPackageBookingErrorEvent('package_booking_error', smErrorData);
};

export const packageBooking = (checkoutPackageResponse, paymentType, referrerPage, paidStatus, referenceNumber) => {
  const itemData = {
    screen_name: SCREEN_NAME?.ORDER_CONFIRMATION,
    page_type: PAGE_NAME?.PACKAGE,
    package_name: checkoutPackageResponse?.packageDetails?.title,
    package_type: checkoutPackageResponse?.isHomeSampleCollectionAllowed ? PACKAGE_TYPE?.HOME_SAMPLE : PACKAGE_TYPE?.CLINIC_PACKAGE,
    no_of_services: Number(checkoutPackageResponse?.noOfService),
    package_id: String(checkoutPackageResponse?.packageDetails?.packageId),
    facility_id: getFacilityId(checkoutPackageResponse?.clinicDetails?.id, checkoutPackageResponse?.isHomeSampleCollectionAllowed),
    facility_name: getfacilityName(checkoutPackageResponse?.clinicDetails?.name, checkoutPackageResponse?.isHomeSampleCollectionAllowed),
    facility_type: checkoutPackageResponse?.hisSystemName === HISSYSTEM?.AKHIL ? FACILITYNAME?.HOSPITAL : FACILITYNAME?.CLINIC,
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
    payment_type: paymentType?.toLowerCase(),
    payment_status: paidStatus,
    currency: 'AED',
    secure_points_earned: checkoutPackageResponse?.securePoints,
    package_status: checkoutPackageResponse?.packageStatus?.toLowerCase(),
    booking_id: referenceNumber,
    speciality: checkoutPackageResponse?.speciality,
    price: checkoutPackageResponse?.netPrice,
    order_value:checkoutPackageResponse?.netPrice,
    promotion_discount: checkoutPackageResponse?.promotionAmount,
    promotion_applied: Number(checkoutPackageResponse?.netPrice) - Number(checkoutPackageResponse?.patientPayableAmount),
    payment_amount: checkoutPackageResponse?.patientPayableAmount,
    ...(referrerPage ? { referrer_page: referrerPage } : {}),
  };
  dataLayerSendEvent('package_booking', itemData);

  sendSmPackageBookingEvent('package_booking', itemData);
};

export const sendShareEvent = (details, screenName, pageType, refererPage, sectionName) => {
  const shareItemData = {
    screen_name: screenName,
    page_type: pageType,
    ...(refererPage ? { referrer_page: refererPage?.toLowerCase() } : {}),
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
    ...(sectionName ? { section_name: sectionName } : {}),
    package_name: details?.name,
    price: details?.netPrice || details?.price,
    ...(details?.isHomeSampleCollectionAllowed !== undefined && details?.isHomeSampleCollectionAllowed !== 'undefined'
      ? {
          package_type: details?.isHomeSampleCollectionAllowed ? PACKAGE_TYPE?.HOME_SAMPLE : PACKAGE_TYPE?.CLINIC_PACKAGE,
        }
      : {}),
  };

  dataLayerSendEvent('share_package_details', shareItemData);

  const smShareItem = {
    screen_name: screenName,
    page_type: pageType,
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
  };

  sendSmClickaShareEvent('share_package_details', smShareItem);
};

export const sendFilterClickEvent = (screenName, pageType, refererPage, selection) => {
  const itemData = {
    screen_name: screenName,
    page_type: pageType,
    ...(refererPage ? { referrer_page: refererPage } : {}),
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
    filter_category: TYPE?.PACKAGE,
    filter_value: PACKAGE_TYPE?.MYASTER_EXCLUSIVE,
    selection: selection ? FILTER_SELECTION?.ENABLED : FILTER_SELECTION?.DISABLED,
  };
  dataLayerSendEvent('filter_click', itemData);
  const smShareItem = {
    screen_name: screenName,
    page_type: pageType,
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
    filter_category: TYPE?.PACKAGE,
    filter_value: PACKAGE_TYPE?.MYASTER_EXCLUSIVE,
  };

  sendSmFilterClickEvent('filter_click', smShareItem);
};

export const sendInfoPopupViewedEvent = (details, pageType, refererPage) => {
  const itemData = {
    screen_name: details?.name,
    page_type: pageType,
    ...(refererPage ? { referrer_page: refererPage } : {}),
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
    package_name: details?.name,
    ...(details?.isHomeSampleCollectionAllowed !== undefined && details?.isHomeSampleCollectionAllowed !== 'undefined'
      ? {
          package_type: details?.isHomeSampleCollectionAllowed ? PACKAGE_TYPE?.HOME_SAMPLE : PACKAGE_TYPE?.CLINIC_PACKAGE,
        }
      : {}),
  };
  dataLayerSendEvent('info_popup_viewed', itemData);

  const smShareItem = {
    page_type: pageType,
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
  };

  sendSmInfoPopupViewedEvent('info_popup_viewed', smShareItem);
};

export const addToCartPackageEvent = (packageDetails, referrerpage = '', facilityId, facilityName) => {
  const itemData = {
    screen_name: packageDetails?.name,
    page_type: PAGE_NAME?.PDP,
    ...(referrerpage ? { referrer_page: referrerpage } : {}),
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
    package_name: packageDetails?.name,
    currency: 'AED',
    price: packageDetails?.netPrice,
    promotion_discount: packageDetails?.savedAmount,
    no_of_services: packageDetails?.packageContentSize,
    package_id: String(packageDetails?.packageId),
    ...(packageDetails?.isHomeSampleCollectionAllowed !== undefined &&
    packageDetails?.isHomeSampleCollectionAllowed !== 'undefined'
      ? {
          package_type: packageDetails?.isHomeSampleCollectionAllowed
            ? PACKAGE_TYPE?.HOME_SAMPLE
            : PACKAGE_TYPE?.CLINIC_PACKAGE,
        }
      : {}),
    speciality: packageDetails?.speciality,
    ...(facilityId ? { facility_id: facilityId } : {}),
    ...(facilityName ? { facility_name: facilityName } : {}),
    ...(packageDetails?.hisSystemName
      ? { facility_type: packageDetails?.hisSystemName === HISSYSTEM?.AKHIL ? FACILITYNAME?.HOSPITAL : FACILITYNAME?.CLINIC }
      : {}),
  };
  dataLayerSendEvent('add_package_to_cart', itemData);
};

export const selectFacilityEvent = (
  packageDetails,
  screenName,
  pageType,
  refererPage,
  facilityId,
  facilityName,
) => {
  const itemData = {
    screen_name: screenName,
    page_type: pageType,
    ...(refererPage ? { referrer_page: refererPage } : {}),
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
    package_name: packageDetails?.name,
    price: packageDetails?.netPrice,
    promotion_discount: packageDetails?.savedAmount,
    no_of_services: packageDetails?.packageContentSize,
    package_id: String(packageDetails?.packageId),
    ...(packageDetails?.isHomeSampleCollectionAllowed !== undefined &&
    packageDetails?.isHomeSampleCollectionAllowed !== 'undefined'
      ? {
          package_type: packageDetails?.isHomeSampleCollectionAllowed
            ? PACKAGE_TYPE?.HOME_SAMPLE
            : PACKAGE_TYPE?.CLINIC_PACKAGE,
        }
      : {}),
    speciality: packageDetails?.speciality,
    ...(facilityId ? { facility_id: facilityId } : {}),
    ...(facilityName ? { facility_name: facilityName } : {}),
    ...(packageDetails?.hisSystemName
      ? { facility_type: packageDetails?.hisSystemName === HISSYSTEM?.AKHIL ? FACILITYNAME?.HOSPITAL : FACILITYNAME?.CLINIC }
      : {}),
  };
  dataLayerSendEvent('select_facility', itemData);
};

export const confirmationPackageClickEvent = (
  packageDetails,
  screenName,
  pageType,
  paymentType,
  referrerPage,
  facilityName,
  facilityId,
  promotionApplied,
  paymentamount,
) => {
  const itemData = {
    screen_name: screenName,
    page_type: pageType,
    ...(referrerPage ? { referrer_page: referrerPage } : {}),
    package_name: packageDetails?.name,
    ...(packageDetails?.isHomeSampleCollectionAllowed !== undefined &&
    packageDetails?.isHomeSampleCollectionAllowed !== 'undefined'
      ? {
          package_type: packageDetails?.isHomeSampleCollectionAllowed
            ? PACKAGE_TYPE?.HOME_SAMPLE
            : PACKAGE_TYPE?.CLINIC_PACKAGE,
        }
      : {}),
    price: packageDetails?.netPrice || packageDetails?.patientPayableAmount || packageDetails?.price || '',
    promotion_discount: packageDetails?.savedAmount || packageDetails?.SavedAmount || packageDetails?.discount || '',
    no_of_services: packageDetails?.packageContentSize || packageDetails?.countOfServicesListed || '',
    package_id: String(packageDetails?.packageId),
    ...(facilityId ? { facility_id: facilityId } : {}),
    ...(facilityName ? { facility_name: facilityName } : {}),
    ...(packageDetails?.hisSystemName
      ? { facility_type: packageDetails?.hisSystemName === HISSYSTEM?.AKHIL ? FACILITYNAME?.HOSPITAL : FACILITYNAME?.CLINIC }
      : {}),
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
    payment_type: paymentType?.toLowerCase(),
    payment_amount: paymentamount,
    order_value: packageDetails?.netPrice,
    promotion_applied: promotionApplied,
    currency: 'AED',
    secure_points_earned: packageDetails?.securePoints,
    speciality: packageDetails?.speciality || '',
  };
  dataLayerSendEvent('confirm_package_click', itemData);
};

export const sendViewAllLinkEvent =(screenName, pageType, refererPage, sectionName)=>{
  const itemData ={
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
    page_type: pageType,
    screen_name: screenName,
    ...(refererPage ? { referrer_page : refererPage} : {}),
    section_name: sectionName,
    type: TYPE?.PACKAGE,
  };
  dataLayerSendEvent('view_all_link_click', itemData);
  sendSmViewAllLinkEvent('view_all_link_click', itemData);
}

export const sendViewMypackageDetails = (packageDetails, screenName, pageType, referrerPage) => {
  const itemData = {
    screen_name: screenName,
    page_type: pageType,
    ...(referrerPage ? { referrer_page: referrerPage } : {}),
    package_name: packageDetails?.packageDetail?.name,
    ...(packageDetails?.isHomeSampleCollectionAllowed !== undefined &&
    packageDetails?.isHomeSampleCollectionAllowed !== 'undefined'
      ? {
          package_type: packageDetails?.isHomeSampleCollectionAllowed
            ? PACKAGE_TYPE?.HOME_SAMPLE
            : PACKAGE_TYPE?.CLINIC_PACKAGE,
        }
      : {}),
    price: packageDetails?.packageDetail?.netPrice || '',
    no_of_services: packageDetails?.packageDetail?.packageContentSize || '',
    package_id: String(packageDetails?.packageDetail?.packageId),
    ...(packageDetails?.packageDetail?.facilityName
      ? { facility_name: packageDetails?.packageDetail?.facilityName }
      : {}),
    ...(packageDetails?.hisSystemName
      ? { facility_type: packageDetails?.hisSystemName === HISSYSTEM?.AKHIL ? FACILITYNAME?.HOSPITAL : FACILITYNAME?.CLINIC }
      : {}),
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
    speciality: packageDetails?.packageDetail?.speciality,
    package_status: packageDetails?.packageDetail?.bookingStatus?.toLowerCase(),
    booking_id: packageDetails?.packageDetail?.referenceNumber,
  };
  dataLayerSendEvent('view_my_package_details', itemData);
};

export const sendAddPaymentInfoInitiatedEvent = (screenName, pageType, paymentType, paymentAmount) => {
  const itemData = {
    screen_name: screenName,
    page_type: pageType,
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
    payment_type: paymentType?.toLowerCase(),
    payment_amount: paymentAmount,
    currency: 'AED',
  };
  dataLayerSendEvent('add_payment_info_initiated', itemData);
};

export const sendAddPaymentInfoStatusEvent = (screenName, paymentType, paymentAmount, paymentStatus, error) => {
  const itemData = {
    screeen_name: screenName,
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
    payment_type: paymentType?.toLowerCase(),
    ...(error ? { error } : {}),
    ...(error ? { err_type: ERROR_TYPE.API_ERROR } : {}),
    payment_amount: paymentAmount,
    payment_status: paymentStatus,
    currency: 'AED',
  };
  dataLayerSendEvent('add_payment_info_status', itemData);
};

export const sendBannerClickEvent = (
  screenName,
  pageType,
  refererPage,
  bannerName,
  bannerPageSlot,
  bannerDetails,
  bannerPosition,
) => {
  const itemData = {
    screen_name: screenName,
    page_type: pageType,
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
    referrer_page: refererPage,
    banner_name: bannerName,
    banner_url: bannerDetails?.imageForWeb || bannerDetails?.bannerImage,
    banner_id: bannerDetails?.id || bannerDetails?.bannerId,
    banner_position: bannerPosition,
    banner_page_slot: bannerPageSlot,
    banner_title: bannerDetails?.displayName || bannerDetails?.bannerName,
  };
  dataLayerSendEvent('banner_click', itemData);
};

export const packageChangeLocation = (screenName, pageType) => {
  const itemData = {
    screen_name: screenName,
    page_type: pageType,
  };
  dataLayerSendEvent('change_location', itemData);
};